<template>
<div class="wrap_app">
    <p v-html="content.replace(/\n/gi,'<br />')"></p>
</div>
</template>

<script>
import "@/utils/flexible";
import {appversion,user_id,CURRENT_ENV_PRE } from "@/utils/urlQuery";
export default {
    data() {
        return {
            content:'',
            tip:'网络原因，请稍后再试',
            kind:this.$route.query.kind,//warning agreement
            month_price:this.$route.query.month_price,//没有就不传
            id:this.$route.query.id,
            name:this.$route.query.name,//协议名称
        };
    },
    created() {
        this.getdata();   
        
    },
    mounted() {
        //需要修改title
        document.title = this.name;
    },
    methods:{
        getdata() {

            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: "get",
                url: `https://app${CURRENT_ENV_PRE}.aigupiao.com/api/support.php`,
                data:{
                    act:_this.kind,
                    id:_this.id,
                    month_price:_this.month_price,
                },
                cache: false,
                async: true,
                error: function () {
                    return false;
                },
                success: function (res) {
                    if(res.rslt == "succ") {
                        _this.content = res.content;
                    }
                    else {
                        alert(_this.tip);
                    }
                },
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/sass/global.scss";
    .wrap_app{
        display: flex;
        align-items: center;
        flex-direction: column;
        background: #F8F8F8;
        min-height: 100vh;
        padding: rem2(12px);
        box-sizing: border-box;
        p{
            
            font-size: rem2(15px);
            color: #636363;
            line-height: 150%;
        }

    }
    
</style>